import React from "react";
import { GatsbyRootWrapper } from "./src/theme/gatsbyRootWrapper";
import { loadTheme } from "./src/theme/loadTheme";
import "./src/theme/global.css";

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.gatsbyOnClientEntry = "1";
    window.__themeGatsbyBrowser = { onClientEntry: true };
  }

  if (process.env.NODE_ENV === "development") {
    console.log("[theme] gatsby-browser onClientEntry");
  }

  loadTheme();
};

/** Apply theme before the next page paints (avoids light flash on client navigations). */
export const onPreRouteUpdate = () => {
  loadTheme();
};

export const onRouteUpdate = () => {
  if (process.env.NODE_ENV === "development") {
    console.log("[theme] gatsby-browser onRouteUpdate");
  }
};

export const wrapRootElement = ({ element }) => {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.gatsbyWrapRootElement = "1";
    window.__themeGatsbyBrowser = {
      ...window.__themeGatsbyBrowser,
      wrapRootElement: true,
    };
  }

  if (process.env.NODE_ENV === "development") {
    console.log("[theme] gatsby-browser wrapRootElement");
  }

  return <GatsbyRootWrapper source="browser">{element}</GatsbyRootWrapper>;
};
